// extracted by mini-css-extract-plugin
export var aggregationCell = "_20-f";
export var aggregationRow = "_20-e";
export var borderlessSpinnerContainer = "_20-2";
export var closeIcon = "_20-7";
export var expandIcon = "_20-8";
export var expanded = "_20-9";
export var filterDropdown = "_20-a";
export var filterDropdownDivider = "_20-5";
export var filterDropdownHeader = "_20-d";
export var filterDropdownItem = "_20-c";
export var filterDropdownModal = "_20-b _20-a";
export var filterItem = "_20-4";
export var normalCellWithAdjustableBorder = "_20-6";
export var pinButtonContainer = "_20-g";
export var pinIcon = "_20-h";
export var pinIconActive = "_20-i";
export var spinner = "_20-0";
export var spinnerContainer = "_20-1";
export var tableContainer = "_20-3";
export var viewButtonContainer = "_20-j";